var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRocketLauncherSpnKr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.362 18.4426L109.751 16.5211L107.6 15.5296C107.6 15.5296 99.1508 15.1756 97.2563 15.5326C95.3618 15.8896 94.4828 17.8936 94.4828 17.8936L76.6613 17.7841L75.9473 15.7516V13.1431L75.4523 12.3196L73.7228 12.3466L71.8823 12.7591L71.0033 13.2271C71.0033 13.2271 64.4423 13.2001 63.4508 13.1746C62.4593 13.1491 62.3078 12.6496 62.3078 12.6496L62.3813 11.8801H71.0033L71.6348 11.2216L71.2088 9.60156L70.5638 10.0681C70.5638 10.0681 61.5443 10.0741 60.8138 10.3111C60.0833 10.5481 60.2393 11.2216 59.9918 11.7376C59.7443 12.2536 58.6748 12.8416 58.6748 12.8416H57.4118L56.4788 12.3466V11.3026C56.4788 10.8901 52.7438 10.5061 52.7438 10.5061H47.3618V15.7051H50.9858L50.4098 17.5366H41.5958L40.8263 16.8781H39.8933L38.9603 17.5366H38.1368L37.1483 16.5481L36.1043 17.5921L21.8798 17.4826L21.2753 16.5496H19.6823L18.3638 17.3731L17.4848 16.5496L15.7268 17.1916C15.7268 17.1916 8.2028 16.9351 7.2143 17.1811C6.2258 17.4286 5.2928 19.9546 5.2928 19.9546C5.2928 19.9546 3.9203 19.9546 3.0338 20.2246C2.1473 20.4946 1.6673 21.9721 1.4753 23.4151C1.2833 24.8581 2.8748 26.3536 2.8748 26.3536L5.8958 26.8201L6.8708 26.1466H12.0473L13.5308 26.3521L15.3563 26.1466L16.9898 26.5591L19.0763 26.2291L34.2338 26.1466L35.6618 26.5996L37.0523 26.2576L38.1338 26.5996L39.0668 26.7151L39.8633 26.2696L51.0938 26.5996V28.1101H46.9748L45.7118 27.7261H41.8118L41.5373 28.2211L38.9018 28.1251L38.1323 27.9466H36.6218L36.0998 28.7431L33.8483 28.9081L33.3128 28.1671H27.6968L26.9828 29.0326H26.0633L24.7868 28.7446L23.9408 29.3626L23.7578 31.0096L25.1168 31.9156H26.6408L23.7188 38.6701L22.9328 39.0406L23.2628 41.1826C23.2628 41.1826 25.4048 41.4706 25.8803 41.4031C26.3558 41.3356 27.2993 40.8121 27.2588 40.2766C27.2183 39.7411 27.2588 39.4936 27.2588 39.4936C27.2588 39.4936 27.8123 38.8096 28.2023 38.2516C28.5923 37.6936 29.3993 35.9506 29.7578 34.8511C30.1178 33.7531 30.2648 32.5741 30.2648 32.5741C30.2648 32.5741 32.6198 32.2561 33.1073 31.9981C33.5948 31.7401 34.2338 31.5856 34.2338 31.5856L36.6548 31.9111L37.0103 32.4916C37.3658 33.0721 39.6458 34.1896 40.0553 34.5796C40.4663 34.9696 41.4593 37.1026 42.0608 38.2501C42.6608 39.3991 44.2418 40.8886 44.9978 41.4811C45.7538 42.0736 48.9938 43.1371 48.9938 43.1371L49.8998 43.7341L50.3558 44.3611L52.4153 46.2886L54.4988 46.0966L55.1303 45.6706H69.6428L70.3223 46.1566L71.0018 45.6706C71.0018 45.6706 71.9603 45.3226 72.3998 44.9956C72.8393 44.6686 72.8963 43.4056 72.8963 43.4056L73.1453 40.6456C73.1453 40.6456 72.9503 39.7801 73.3208 37.5241C73.6898 35.2681 75.2378 34.1296 75.9308 33.7126C76.6238 33.2956 78.4928 32.8801 78.4928 32.8801L80.8883 32.7766H98.6543L100.658 35.1661H109.637L110.296 28.4116H109.133L110.107 27.2581L111.778 26.6536L115.1 26.5156C115.1 26.5156 115.772 25.6906 116.129 25.0126C116.485 24.3346 116.701 22.5466 116.701 22.5466L117.902 18.8821L117.358 18.4426H117.362ZM49.8608 34.4521C49.8338 35.3581 49.9988 36.8956 49.2563 38.1586C48.5153 39.4216 47.7188 39.6961 46.1813 39.6136C44.6438 39.5311 44.0948 37.7191 44.2313 36.7306C44.3693 35.7421 44.3963 33.1876 44.3963 33.1876C44.4248 31.8676 46.3178 31.7596 47.9393 31.9801C49.5593 32.1991 49.8893 33.5446 49.8608 34.4521V34.4521ZM60.3773 34.6036C60.3773 35.8696 59.3513 36.8971 58.0838 36.8971H55.6538C54.3878 36.8971 53.3603 35.8711 53.3603 34.6036C53.3603 33.3376 54.3863 32.3101 55.6538 32.3101H58.0838C59.3498 32.3101 60.3773 33.3361 60.3773 34.6036Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.281 25.6637C102.281 25.6637 102.721 23.4122 102.83 22.9727C102.94 22.5332 104.423 22.5452 104.423 22.5452L105.082 23.6252H107.882L108.487 22.3127H109.75C109.75 22.3127 110.299 23.0822 109.475 25.6622",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M102.68 33.4352H108.57",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M100.949 15.8057C100.949 15.8057 103.022 18.1127 102.83 22.9727",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M102.68 15.8057C102.68 15.8057 104.423 18.1232 104.423 22.5467",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M104.423 15.8057C104.423 15.8057 106.106 18.3482 106.106 23.6267",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M106.107 15.9707C106.107 15.9707 107.953 18.8432 107.541 23.6267",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M113.142 20.9132C113.142 20.9132 114.498 21.8717 112.976 26.6027",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9954 21.2297V26.1452",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7258 21.2297V26.3402",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.7114 21.2297V26.3402",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8303 21.2297V26.3402",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8704 18.1532V20.7482",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1543 18.1532V20.8532",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1604 17.8937V20.7482",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8909 17.8937V20.7482",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0237 15.0092V27.2912",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7415 27.4217H62.7935L64.043 27.0917H71.9105",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7649 28.9037H63.5904L64.8264 28.1222H71.9109",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4905 31.6637V35.7587H71.005",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.4906 35.7587V41.9612H56.8706L55.3541 40.6427L53.0066 36.4832C53.0066 36.4832 50.7416 32.4047 55.1066 31.4582H64.4981L65.4041 32.0762H72.2006V31.2527",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3519 40.6442L50.4094 43.7327",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8704 29.7692V30.5522H67.5459L68.3274 29.3582H64.8264L64.2504 29.7902L56.8704 29.7692Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M68.678 30.5522L69.605 29.3582H70.325V30.5522H68.678Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6672 17.7827H62.3277C61.964 17.7827 61.6692 18.0775 61.6692 18.4412V18.4427C61.6692 18.8064 61.964 19.1012 62.3277 19.1012H69.6672C70.0309 19.1012 70.3257 18.8064 70.3257 18.4427V18.4412C70.3257 18.0775 70.0309 17.7827 69.6672 17.7827Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6672 24.3527H62.3277C61.964 24.3527 61.6692 24.6475 61.6692 25.0112V25.0127C61.6692 25.3763 61.964 25.6712 62.3277 25.6712H69.6672C70.0309 25.6712 70.3257 25.3763 70.3257 25.0127V25.0112C70.3257 24.6475 70.0309 24.3527 69.6672 24.3527Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0715 21.1501H72.899",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0715 23.1647H63.0695L64.1945 22.0938H71.21L72.899 23.1647",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5803 35.3822L41.4863 34.2317L41.1008 33.4352L44.2118 30.1607H51.8648",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3596 25.7747V22.6292H55.1331V25.6712",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6304 21.1502H52.5789H57.7419H52.5789V19.2932H54.4194V21.1502",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2524 12.6482H52.5519",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4172 15.8342H57.0837",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9722 45.5732C62.9512 45.5867 62.9722 37.6997 62.9722 37.6997H63.5902V40.5422L64.1047 41.0567V44.7017H65.5252V40.8302L64.8037 40.1087V37.4732L65.5252 35.8877H67.5442V37.3712L69.0367 38.8637V44.4962L69.6442 45.6707",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0384 44.4947H65.5269",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9758 35.8862V43.1357",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5991 34.8467C62.6737 34.8467 62.7341 34.7862 62.7341 34.7117C62.7341 34.6371 62.6737 34.5767 62.5991 34.5767C62.5246 34.5767 62.4641 34.6371 62.4641 34.7117C62.4641 34.7862 62.5246 34.8467 62.5991 34.8467Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8042 44.6296C61.8787 44.6296 61.9392 44.5692 61.9392 44.4946C61.9392 44.4201 61.8787 44.3596 61.8042 44.3596C61.7296 44.3596 61.6692 44.4201 61.6692 44.4946C61.6692 44.5692 61.7296 44.6296 61.8042 44.6296Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8823 44.0027C52.9569 44.0027 53.0173 43.9422 53.0173 43.8677C53.0173 43.7931 52.9569 43.7327 52.8823 43.7327C52.8078 43.7327 52.7473 43.7931 52.7473 43.8677C52.7473 43.9422 52.8078 44.0027 52.8823 44.0027Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3979 31.7987C51.4725 31.7987 51.5329 31.7382 51.5329 31.6637C51.5329 31.5891 51.4725 31.5287 51.3979 31.5287C51.3234 31.5287 51.2629 31.5891 51.2629 31.6637C51.2629 31.7382 51.3234 31.7987 51.3979 31.7987Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9758 34.8467C70.0504 34.8467 70.1108 34.7862 70.1108 34.7117C70.1108 34.6371 70.0504 34.5767 69.9758 34.5767C69.9013 34.5767 69.8408 34.6371 69.8408 34.7117C69.8408 34.7862 69.9013 34.8467 69.9758 34.8467Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3848 41.9612V41.0417H59.9933L60.0233 41.9612",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M100.949 33.0647C101.108 33.0647 101.237 32.9358 101.237 32.7767C101.237 32.6177 101.108 32.4887 100.949 32.4887C100.79 32.4887 100.661 32.6177 100.661 32.7767C100.661 32.9358 100.79 33.0647 100.949 33.0647Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M3.12335 26.5156C3.12335 26.5156 1.47485 25.6636 1.47485 23.1931C1.47485 20.7226 3.53435 19.9531 3.53435 19.9531H5.51135C5.51135 19.9531 5.84135 16.9321 7.92785 17.2066L15.7264 17.1886L16.8799 16.5466H17.9779L18.3619 17.3701L19.6804 16.5466H21.2734L21.8779 17.4796L36.1024 17.5891L36.6514 16.5451H37.6398L38.1349 17.5336H38.9584L39.6168 16.8751H41.1004L41.5954 17.5336H50.7124L50.9869 15.7021H47.3629V10.5031H52.7449C52.7449 10.5031 55.2169 10.5031 56.4799 11.2996V12.3436C56.4799 12.3436 56.9194 12.5626 57.0844 12.8386L58.9249 12.8116C58.9249 12.8116 59.9959 12.0706 60.2434 11.2186C60.4909 10.3666 60.9844 10.0651 61.6984 10.0651H70.5679L71.1168 9.59863H71.6389V11.8771H62.3854L62.3029 12.7561C62.3029 12.7561 62.4949 13.0306 63.0439 13.1401C63.5929 13.2496 71.4738 13.2226 71.4738 13.2226L71.8863 12.7561H72.7099L73.1494 12.3166H75.4564L75.9514 13.1401V15.7486C75.9514 15.7486 76.7209 16.7926 76.6654 17.7811L94.4868 17.8906C94.4868 17.8906 94.6248 16.2436 97.2603 15.5296H107.997C107.997 15.5296 108.93 15.7771 109.755 16.5181L117.17 18.3586C117.17 18.3586 117.911 18.6331 117.911 18.8806C117.911 19.1281 116.456 23.2741 116.456 23.2741C116.456 23.2741 116.648 25.0036 115.11 26.5141L111.788 26.6521C111.788 26.6521 111.018 26.9821 110.304 26.9821C110.304 26.9821 110.03 27.5311 108.903 28.4101H110.661L109.646 35.1646H100.667L98.6628 32.7751L80.4018 32.6926C80.4018 32.6926 73.3174 32.6101 73.3174 37.8826L73.0699 42.0841C73.0699 42.0841 73.6458 45.5716 70.8453 45.5716L70.2139 46.2856L69.7189 45.9016H62.8819L62.2774 45.7636H54.9454L54.5059 46.0936H52.3084L50.0299 44.0611L50.3044 43.5946C50.3044 43.5946 44.4559 41.7001 43.1104 39.8881C41.7649 38.0761 41.0779 36.0436 40.2004 34.7536C39.3229 33.4636 36.6859 33.0241 36.6304 31.7056C36.5749 30.3871 36.4924 28.7401 36.4924 28.7401L36.2179 28.0816L36.3829 27.6976H38.4979V28.2196H41.5459V27.7246H46.3519L46.9834 28.1086H51.1024V26.2681H39.8719L39.4189 26.7211L37.6474 26.6806L37.4419 26.2681L36.2479 26.2276L35.6719 26.5981H34.6834L34.2304 26.1451H18.7759L18.1174 26.5981H16.2229L15.3574 26.1451H14.9044L14.2864 26.5576H12.9679L12.2269 26.1451H6.87185L6.62435 26.7631H4.39985L3.12335 26.5156V26.5156Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M36.488 28.7403H33.8525L33.317 28.1643H27.4685L27.221 29.0298H26.0675C26.0675 29.0298 24.8315 28.5348 24.2135 29.0298C23.5955 29.5248 23.7185 30.6768 23.7605 31.0068C23.8025 31.3368 24.296 31.9548 25.1195 31.9128C25.943 31.8723 26.1905 31.7073 26.1905 31.7073L26.6435 31.9158C26.6435 31.9158 25.9025 33.3138 25.037 35.3328C24.1715 37.3518 23.7215 38.6688 23.7215 38.6688L22.9355 39.0393C22.9355 39.0393 22.73 40.7688 23.2655 41.1813C23.2655 41.1813 24.4595 41.5518 25.4075 41.4693C26.3555 41.3868 27.0965 41.0163 27.302 40.8108C27.5075 40.6053 27.632 39.9453 27.632 39.9453L27.2615 39.4923C27.2615 39.4923 28.373 38.2983 29.198 36.4443C30.0215 34.5903 30.269 32.5728 30.269 32.5728C30.269 32.5728 32.3285 32.6133 33.1115 31.9968L33.524 31.5843L36.6275 31.7073",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3957 33.1877C44.3957 33.1877 44.3687 35.7422 44.2307 36.7307C44.0927 37.7192 44.6432 39.5312 46.1807 39.6137C47.7182 39.6962 48.5147 39.4217 49.2557 38.1587C49.9967 36.8957 49.8317 35.3582 49.8602 34.4522C49.8872 33.5462 49.5587 32.2007 47.9387 31.9802C46.3187 31.7612 44.4242 31.8677 44.3957 33.1877V33.1877Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0851 32.3102H55.6551C54.3884 32.3102 53.3616 33.3367 53.3616 34.6029C53.3616 35.8692 54.3884 36.8957 55.6551 36.8957H58.0851C59.3517 36.8957 60.3786 35.8692 60.3786 34.6029C60.3786 33.3367 59.3517 32.3102 58.0851 32.3102Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5645 26.3102C76.5825 26.1887 94.359 26.3102 94.359 26.3102C94.359 26.3102 94.5645 27.6287 96.2955 28.3292H76.0305V27.5882C76.0305 27.5882 76.443 27.1352 76.566 26.3117L76.5645 26.3102Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0188 20.9132H97.7773C97.7773 20.9132 100.269 22.9937 98.0038 26.3387L94.3588 26.3087",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M94.4827 17.8938H95.3887C95.3887 17.8938 96.6247 18.9378 96.0472 20.7498",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2557 15.5313C97.2557 15.5313 99.5897 15.2568 99.7817 20.7483C99.9737 26.2398 97.4747 28.1343 96.2942 28.3278H98.6417C98.6417 28.3278 101.442 27.4623 101.772 25.9383H110.298V26.9823L108.198 29.5638H100.166L98.6417 28.3278",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M110.299 25.9383C110.299 25.9383 113.155 21.7638 109.75 16.5198",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M111.375 20.9132H114.542C114.542 20.9132 116.67 21.7937 116.45 23.2742",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M111.42 20.1317H116.231L115.625 21.5762",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0292 28.3278V30.9228H72.1982V26.1033L76.5647 26.3088C77.5532 21.2838 76.6607 17.7828 76.6607 17.7828",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M109.97 30.9227H76.0297C76.0297 30.9227 71.9512 31.4987 71.2102 35.9477V45.5717",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5608 30.9227V32.7767",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5127 19.9532H7.2152V20.4467H12.1847L12.7202 19.2932H14.4377L15.0137 20.4467H15.3437L16.4687 19.2932H18.2267L18.6107 20.4467H34.2362L34.9502 19.4312L35.8007 19.2932L36.2957 20.4467H37.4207L37.9982 19.4582H39.5897L40.0022 20.5562H50.4092V17.5367L51.7277 17.1797H56.6432L57.7412 17.8937V27.4217H55.6547V26.3402L55.1057 25.8287H52.5512L52.1117 26.3402V30.5252L52.5242 31.0742H54.9122L55.3802 30.9227L55.6547 27.4217",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4094 20.5563V26.2683",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4211 20.4468V26.2683",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2366 20.4468V26.1453",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2961 20.4468V26.2278",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0999 16.8767V20.4467",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6184 16.8768L39.5899 19.4583L39.4114 26.7213",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1018 17.5907V19.2932",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1348 17.5367V19.4582",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2268 19.2932V26.5982",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M16.469 19.2932V26.5982",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M12.72 19.4313V26.3508",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4377 19.2932V26.5562",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2747 16.5483V20.3373",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6816 16.5483V20.4468",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7624 16.6128L16.7024 19.2933",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0524 16.7028L17.9924 19.2393",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M7.21509 19.9532V26.2682",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8674 17.5367V20.4467",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6431 31.9128C26.6431 31.9128 26.6026 31.2513 27.2191 30.9228C27.8356 30.5943 31.0081 30.6063 31.2151 31.0743C31.4206 31.5408 31.2151 32.3103 31.2151 32.3103",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8508 28.7402V31.5812",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9468 15.7518V16.8768H73.0098V12.7578",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M73.0098 16.8768V26.1453",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0823 12.8402V17.1797",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4786 12.3468H52.3596V16.8768",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4114 15.0093H62.0794H73.0099",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketLauncherSpnKr);
export default __webpack_public_path__ + "static/media/Rocket Launcher SPNKr.0f0cfe24db0074cb30171ba4f5ea0276.svg";
export { ForwardRef as ReactComponent };